import React, { useState, useEffect, useRef } from 'react';
import { number, shape, string, bool } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { r_times, s_tag } from '@fiverr-private/fit/icons';
import { COUPON_LEARN_MORE_URL } from '../constants';
import { Events } from '../lib/mixpanelEvents';
import { BQ_EVENT_TYPES } from '../lib/reportEvent';
import { sendBombaBigQueryEvent, sendBombaMixpanelEvent } from './biEvents';

import colors from './style.scss';

const CouponBomba = ({ coupon, userId, sellerId, ignoreOnMountEvents = false, className }) => {
    const [isVisible, setVisible] = useState(true);
    const textRef = useRef(null);
    const text = textRef.current && textRef.current.textContent;
    const onClose = () => {
        setVisible(false);
        sendBombaMixpanelEvent(Events.Coupon.DISMISS_BOMBA, coupon, {
            'Bomba Text': text
        });
    };

    const sendEventOnArticleOpen = () => {
        sendBombaMixpanelEvent(Events.Coupon.OPEN_ARTICLE, coupon, {
            'Article Link': COUPON_LEARN_MORE_URL,
            'Bomba Text': text
        });
        sendBombaBigQueryEvent(BQ_EVENT_TYPES.OPEN_COUPON_ARTICLE, {
            userId,
            sellerId,
            group: 'user_action',
            coupon
        });
    };

    useEffect(() => {
        if (ignoreOnMountEvents) {
            return;
        }

        sendBombaMixpanelEvent(Events.Coupon.SEEN_BOMBA, coupon, {
            'Seller ID': sellerId,
            'Discount': coupon.discountValue,
            'Bomba Text': text
        });
        sendBombaBigQueryEvent(BQ_EVENT_TYPES.SEEN_BOMBA_COUPON, {
            userId,
            sellerId,
            group: 'user_impressions',
            coupon
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isVisible) {
        return null;
    }

    const bombaClassNames = classnames(
        'coupon-bomba bg-co-blue-100',
        className
    );

    return (
        <div className={bombaClassNames}>
            <Icon color={colors.icon} className="type-icon">{s_tag}</Icon>
            <div className="bomba-text tbody-6 co-text-dark">
                <span ref={textRef}><I18n k="user_page_perseus.coupon_bomba" params={coupon} parseMarkup/></span>
                {' '}
                <a href={COUPON_LEARN_MORE_URL} target="_blank" rel="noreferrer" onClick={sendEventOnArticleOpen}>
                    <I18n k="user_page_perseus.learn_more"/>
                </a>
            </div>
            <Icon color={colors.close} size={10} onClick={onClose} className="close-icon">{r_times}</Icon>
        </div>
    );
};

CouponBomba.propTypes = {
    coupon: shape({
        couponId: string.isRequired,
        couponType: string.isRequired,
        code: string.isRequired,
        discountValue: number.isRequired,
        providerName: string.isRequired,
        deliveryPackId: string
    }),
    sellerId: number.isRequired,
    userId: string.isRequired,
    ignoreOnMountEvents: bool,
    className: string
};

export default CouponBomba;
